import { FETCH_PRODUCTS_REQUEST, FETCH_PRODUCTS_SUCCESS, FETCH_PRODUCTS_FAILURE, FETCH_UPDATE_PRODUCTS_REQUEST, FETCH_UPDATE_PRODUCTS_SUCCESS, FETCH_UPDATE_PRODUCTS_FAILURE } from "../../actions";
const initialState = {
    fetchProducts: [],
    updateProducts: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCTS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, fetchProducts: null, updateProducts: null });
        case FETCH_PRODUCTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchProducts: action.payload, isLoading: false, error: null, updateProducts: null });
        case FETCH_PRODUCTS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, fetchProducts: null, updateProducts: null });
        case FETCH_UPDATE_PRODUCTS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, fetchProducts: null, updateProducts: null });
        case FETCH_UPDATE_PRODUCTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateProducts: action.payload, fetchProducts: null, isLoading: false, error: null });
        case FETCH_UPDATE_PRODUCTS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, fetchProducts: null, updateProducts: null });
        default:
            return state;
    }
};
export default reducer;
